import {
  CacheEntry,
  CacheKey,
  ICache,
  cacheKeyToString,
} from "../../helpers/utils/cache.util";

export class InMemoryCache implements ICache {
  private cacheMap = new Map<string, CacheEntry<any>>();

  get<T>(key: CacheKey): T | undefined {
    const keyString = cacheKeyToString(key);
    const cachedData = this.cacheMap.get(keyString);

    if (!cachedData) {
      return undefined;
    }

    if (Date.now() > cachedData.expiryTime) {
      this.cacheMap.delete(keyString);
      return undefined;
    }

    return cachedData.data;
  }

  set<T>(key: CacheKey, data: T, timeToLive: number): void {
    const expiryTime = Date.now() + timeToLive * 1000;
    this.cacheMap.set(cacheKeyToString(key), { data, expiryTime });
  }

  delete(key: CacheKey): void {
    this.cacheMap.delete(cacheKeyToString(key));
  }

  clear(): void {
    this.cacheMap.clear();
  }
}

const cache = new InMemoryCache();
export default cache;
